import './panelRecurso.scss';
import { useTheme } from 'context/themeContext';
import { CSSProperties } from 'react';

interface IPanelRecurso {
  children:any,
  styles?:CSSProperties,
  className?:string
}

export default function PanelRecurso(props:IPanelRecurso) {
  const theme = useTheme();
  const { children, styles } = props;
  return (
    <aside
    className={`panelRecurso ${props.className ? props.className :''}`}
    style={{background:theme.colors.gray_200, ...styles}}
    >
      <div id='panelRecurso'>{ children }</div>
    </aside>
  );
}
